// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Panel';



// WEBPACK FOOTER //
// ./components/Panel/index.js